import PinSetScreen from 'features/cardManagement/screens/PinSet/PinSetScreen';
import OnboardingEntryPointWrapper from 'features/onboarding/components/OnboardingEntryPointWrapper/OnboardingEntryPointWrapper';
import React from 'react';

export default function NewPinPage() {
  return (
    <OnboardingEntryPointWrapper>
      <PinSetScreen />
    </OnboardingEntryPointWrapper>
  );
}
